import DecorateTitle from 'components/DecorateTitle';
import SettingItemContainer from './SettingItemContainer';
import { useTranslate } from '@tolgee/react';
import { Radio } from 'antd';
import { useUpdateChatLayoutType } from 'hooks/useChatLayoutType';
import { useNewUIV2Enable } from 'hooks/business/useOrgConfig';

export const ChatLayoutTypeSelect = () => {
  const { t } = useTranslate();
  const { chatLayoutType, changeLayoutType } = useUpdateChatLayoutType();

  const newUIV2Enable = useNewUIV2Enable();

  if (!newUIV2Enable) {
    return null;
  }

  return (
    <>
      <DecorateTitle>{t('app.config.conversationLayout.title')}</DecorateTitle>
      <SettingItemContainer>
        <div className="flex flex-col gap-3">
          <div
            className="border border-solid border-[var(--fett-streak-grey)] rounded-sm flex items-start w-[380px] p-3 cursor-pointer"
            onClick={() => changeLayoutType('CLASSIC')}
          >
            <Radio checked={chatLayoutType === 'CLASSIC'} value="CLASSIC" />
            <div className="flex flex-col gap-2">
              <div>{t('app.config.conversationLayout.type.classic')}</div>
              <div className="text-xs text-[var(--fett-text-tertiary)]">
                {t('app.config.conversationLayout.type.classic.description')}
              </div>
            </div>
          </div>
          <div
            className="border border-solid border-[var(--fett-streak-grey)] rounded-sm flex items-start w-[380px] p-3 cursor-pointer"
            onClick={() => changeLayoutType('LIGHT')}
          >
            <Radio checked={chatLayoutType === 'LIGHT'} value="LIGHT" />
            <div className="flex flex-col gap-2">
              <div>{t('app.config.conversationLayout.type.light')}</div>
              <div className="text-xs text-[var(--fett-text-tertiary)]">
                {t('app.config.conversationLayout.type.light.description')}
              </div>
            </div>
          </div>
        </div>
      </SettingItemContainer>
    </>
  );
};
